import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import userSlice from "../features/user/userSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import muiDrawerSlice from "../components/muidrawer/muiDrawerSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import bannerSlice from "../features/banner/bannerSlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import serviceSlice from "../features/service/serviceSlice";
import faqSlice from "../features/faq/faqSlice";
import usefullinksSlice from "../features/usefullinks/usefullinksSlice";
import contactSlice from "../features/contact/contactSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import ticketBookingSlice from "../features/ticketbooking/ticketBookingSlice";
import workflowSlice from "../features/workflow/workflowSlice";
import industrySlice from "../features/industry/industrySlice";
import uniformSlice from "../features/uniform/uniformSlice";
import clientLogoSlice from "../features/clientlogo/clientLogoSlice";
import aboutSlice from "../features/about/aboutSlice";
import tourSlice from "../features/tour/tourSlice";

import stateSlice from "../features/state/stateSlice";
import citySlice from "../features/city/citySlice";
import countrySlice from "../features/country/countrySlice";
import specialityTypeSlice from "../features/specialitytype/specialityTypeSlice";
import sectorSlice from "../features/sector/sectorSlice";
import roomTypeSlice from "../features/roomtype/roomTypeSlice";
import companySlice from "../features/company/companySlice";
import gstSlice from "../features/gst/gstSlice";
import hotelSlice from "../features/hotel/hotelSlice";
import currencySlice from "../features/currency/currencySlice";
import vehicleSharingPaxSlice from "../features/vehiclesharingpax/vehicleSharingPaxSlice";
import itinearySlice from "../features/itinerary/itinearySlice";
import itineraryfacilitySlice from "../features/ItineraryFacility/itineraryfacilitySlice";
import regionSlice from "../features/region/regionSlice";
import festivalsSlice from "../features/festival/festivalsSlice";
import ourExpertiseSlice from "../features/ourexpertise/ourExpertiseSlice";
import blogSlice from "../features/blog/blogSlice";
import webBranchSlice from "../features/webbranch/webBranchSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dashboard: dashboardSlice,
    dialog: dialogSlice,
    muidrawer: muiDrawerSlice,
    user: userSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    cms: cmsSlice,
    pagination: paginationSlice,
    seotag: seotagSlice,
    service: serviceSlice,
    testimonial: testimonialSlice,
    banner: bannerSlice,
    faq: faqSlice,
    usefullinks: usefullinksSlice,
    contact: contactSlice,
    setting: settingSlice,
    ticketBooking: ticketBookingSlice,
    workflow: workflowSlice,
    industry: industrySlice,
    uniform: uniformSlice,
    clientLogo: clientLogoSlice,
    about: aboutSlice,
    tour: tourSlice,

    country: countrySlice,
    state: stateSlice,
    city: citySlice,
    specialityType: specialityTypeSlice,
    sector: sectorSlice,
    itineary: itinearySlice,
    itinearyfacility: itineraryfacilitySlice,
    roomType: roomTypeSlice,
    company: companySlice,
    hotel: hotelSlice,
    gst: gstSlice,
    currency: currencySlice,
    vehicleSharingPax: vehicleSharingPaxSlice,
    region: regionSlice,
    festivals: festivalsSlice,
    // adminsetting: adminsettingSlice,
    ourExpertise: ourExpertiseSlice,
    blog: blogSlice,
    webBranch: webBranchSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
